export const AGENCY_ROLLOUTS = {
    COBRAS_OPEN_HOURLY_TO_MP: 'cobras_open_hourly_to_mp',
    FALCONS_AGENCIES_AI_BRIEF: 'falcons_agencies_ai_brief',
    MARLINS_LOYALTY_SUNSET: 'marlins_loyalty_sunset',
    MEERKATS_PRO_SKILLS_CATALOG: 'meerkats_pro_skills_catalog',
    STARLINGS_BOOSTING_NEW_GIGS: 'starlings_boosting_new_gigs',
    STARLINGS_FIVERR_GO_FLOATING_CHAT: 'starlings_fiverr_go_floating_chat',
    STARLINGS_FIVERR_GO_INBOX: 'starlings_fiverr_go_inbox',
    ZEBRAS_HOURLY_RATE: 'zebras_hourly_rate',
    ZEBRAS_NEW_LOYALTY_POINTS: 'zebras_new_loyalty_points',
} as const;

export type AgencyRollouts = (typeof AGENCY_ROLLOUTS)[keyof typeof AGENCY_ROLLOUTS];
